import { pdfjs } from "react-pdf";

// Vite-kompatibles Worker-Bundling (self-contained, kein CDN).
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();
